import React, { useRef, useState } from 'react';
import {
  Add as AddIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
} from '@mui/icons-material';
import { HISTORICAL, PROJECTED } from 'common/constants/financials';
import { FinancialsButtonsProps } from './FinancialsButtons.props';
import { DropdownButton, HistoricalButton, ProjectedButton, StyledButtonGroup } from './FinancialsButtons.styles';

const FinancialsButtons = ({ addFinancialYear, isDisabled }: FinancialsButtonsProps) => {
  const [isGroupExpanded, setIsGroupExpanded] = useState(false);
  const yearsRef = useRef(null);

  const Icon = () => <AddIcon fontSize="small" style={{ marginRight: '0.5rem' }} />;

  return (
    <StyledButtonGroup color="primary" variant="outlined" aria-label="split button">
      <ProjectedButton
        id="financials-add-historical-year-btn"
        disabled={isDisabled}
        onClick={() =>
          addFinancialYear({
            isPrevYear: false,
          })
        }>
        <Icon />
        {PROJECTED}
      </ProjectedButton>
      <DropdownButton
        ref={yearsRef}
        size="small"
        aria-label="select year type"
        disabled={isDisabled}
        aria-haspopup="menu"
        aria-controls={isGroupExpanded ? 'split-button-menu' : undefined}
        aria-expanded={isGroupExpanded ? 'true' : undefined}
        onClick={() => setIsGroupExpanded(!isGroupExpanded)}>
        {isGroupExpanded ? <ArrowDropDownIcon id="icon-button-down" /> : <ArrowDropUpIcon id="icon-button-up" />}
      </DropdownButton>
      {isGroupExpanded && (
        <HistoricalButton
          id="financials-add-previous-year-btn"
          onClick={() =>
            addFinancialYear({
              isPrevYear: true,
            })
          }>
          <Icon />
          {HISTORICAL}
        </HistoricalButton>
      )}
    </StyledButtonGroup>
  );
};

export default FinancialsButtons;
